import { useEffect, useRef } from "react";
import { Icon } from "../Icon";

export interface CursorPaginationProps {
  componentId?: string;
  fetchNewPage: (messageId: number | null) => Promise<void> | void;
  footerDistanceFromBottom?: number;
  isLoading: boolean;
  messageId: number | null;
  onEvent?: "scrollDown" | "scrollUp";
}

export const CursorPagination = ({
  fetchNewPage,
  footerDistanceFromBottom = -1000,
  componentId,
  onEvent = "scrollDown",
  messageId,
  isLoading,
}: CursorPaginationProps) => {
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const component = document.getElementById(componentId || "");

    if (!component) return;

    const scrollHandler = () => {
      if (isLoading) {
        return;
      }

      let shouldSendRequest = false;
      if (onEvent === "scrollUp") {
        shouldSendRequest = component.scrollTop < 20;
      } else {
        const position = elementRef?.current?.getBoundingClientRect();
        const windowHeight = component.clientHeight;
        const loc = windowHeight - (position?.top || 0);
        shouldSendRequest = loc > footerDistanceFromBottom;
      }

      if (shouldSendRequest) {
        void fetchNewPage(messageId);
      }
    };

    component.addEventListener("scroll", scrollHandler);

    return () => {
      component.removeEventListener("scroll", scrollHandler);
    };
  }, [messageId, isLoading, componentId]);

  return (
    <div ref={elementRef} className="flex justify-center">
      {isLoading && <Icon type="loader" />}
    </div>
  );
};
